import { initializeApp } from 'firebase/app';
import { getMessaging, getToken } from 'firebase/messaging';

const FCM_TOKEN_KEY = 'saffaFcmToken';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

let app = null;

const isConfigured = () =>
  Boolean(
    firebaseConfig.apiKey &&
      firebaseConfig.projectId &&
      firebaseConfig.messagingSenderId
  );

const getApp = () => {
  if (!app) {
    app = initializeApp(firebaseConfig);
  }
  return app;
};

const getStoredToken = () => {
  try {
    return localStorage.getItem(FCM_TOKEN_KEY) || null;
  } catch {
    return null;
  }
};

const storeToken = (token) => {
  try {
    localStorage.setItem(FCM_TOKEN_KEY, token);
  } catch {}
};

export const clearFcmToken = () => {
  try {
    localStorage.removeItem(FCM_TOKEN_KEY);
  } catch {}
};

export const getFcmToken = async () => {
  if (!isConfigured()) return null;

  const cached = getStoredToken();
  if (cached) return cached;

  if (typeof Notification === 'undefined' || !('serviceWorker' in navigator)) {
    return null;
  }

  try {
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') return null;

    const messaging = getMessaging(getApp());
    const vapidKey = process.env.REACT_APP_FIREBASE_VAPID_KEY || undefined;
    const registration = await navigator.serviceWorker.register(
      '/firebase-messaging-sw.js'
    );
    const token = await getToken(messaging, {
      vapidKey,
      serviceWorkerRegistration: registration,
    });
    if (token) storeToken(token);
    return token || null;
  } catch {
    return null;
  }
};